var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckOn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.75,
    y: 7.75,
    width: 16.5,
    height: 16.5,
    rx: 2.25,
    fill: "#FF7B2E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.75,
    y: 7.75,
    width: 16.5,
    height: 16.5,
    rx: 2.25,
    stroke: "#FF7B2E",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1133 12.3871C21.4517 12.7256 21.4517 13.2743 21.1133 13.6128L15.1133 19.6128C14.7748 19.9512 14.2261 19.9512 13.8876 19.6128L10.8876 16.6128C10.5492 16.2743 10.5492 15.7256 10.8876 15.3871C11.2261 15.0487 11.7748 15.0487 12.1133 15.3871L14.5005 17.7743L19.8876 12.3871C20.2261 12.0487 20.7748 12.0487 21.1133 12.3871Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOn);
export default __webpack_public_path__ + "static/media/checkOn.bc598660fed8e5cc589cf3bf555f16d1.svg";
export { ForwardRef as ReactComponent };